
import { prop, Vue, Options } from "vue-class-component";
import { convertPhoneNumber, formatDate } from "@/app/infrastructures/misc/Utils";
import { PodDexController } from "@/app/ui/controllers/PodDexController";
import { ReasonListDex } from "@/data/payload/api/PodDexRequest";
import startCase from "lodash/startCase";
import CardTabDetail from "../../card-tab-detail.vue";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { ClientDetailUpdateItem, ClientDetailUpdate } from '@/domain/entities/ClientManagement';
import ManagingCountryReadRow from "../managing-country-read-row.vue";

class Props {
  isManagement = prop<boolean>({
    default: false,
    required: true,
    type: Boolean
  });
}

@Options({
  components: {
    CardTabDetail,
    ManagingCountryReadRow
  }
})
class ClientDetailCard extends Vue.with(Props) {
  formatDate = formatDate;
  mounted() {
    PodDexController.getReasonList(
      new ReasonListDex({
        statusCode: "",
        reasonStatus: "active",
        isCreateTicketSf: true
      })
    );
  }

  getReasonList(val: string) {
    const ListReason = PodDexController.reasonList.map(item => {
      return {
        name: item.statusCode + " - " + item.reasonDescription,
        value: item.reasonId
      };
    });

    if (val === "all") {
      return [this.$t("clientManagement.registrationBranchForm.returnConfig.allReasons")];
    } else {
      const ids = val.split(",").map(Number);
      const reasons = ListReason.filter(item => ids.includes(item.value));
      return reasons.map(item => item.name);
    }
  }

  get tabs() {
    return [
      {
        name: this.$t("clientManagement.managementDetail.tabs.client").toString(),
        slotName: "client-info"
      },
      {
        name: this.$t("clientManagement.registrationBranchForm.returnConfig.title").toString(),
        slotName: "config-return"
      },
      {
        name: this.$t("clientManagement.managementDetail.tabs.contact").toString(),
        slotName: "contact"
      },
      {
        name: this.$t("clientManagement.managementDetail.return").toString(),
        slotName: "return"
      },
      {
        name: this.$t("clientManagement.managementDetail.cod").toString(),
        slotName: "cod"
      },
      {
        name: this.$t("clientManagement.managementDetail.parentClientDetail").toString(),
        slotName: "detail-parent-client"
      }
    ];
  }

  convertPhoneNumber: any = convertPhoneNumber;

  get detailDataManagement() {
    return ClientManagementController.detailClientManagement;
  }

  get detailDataRegistration() {
    return ClientRegistrationController.clientRegistrationDetail;
  }

  get detailData() {
    if (this.isManagement) {
      return this.detailDataManagement;
    } else {
      return this.detailDataRegistration;
    }
  }

  get posCommision() {
    if (this.isManagement) {
      return String(
        this.detailDataManagement.clientPartnerCommissionAmount
      );
    } else {
      return String(
        this.detailDataRegistration.clientPartner.clientPartnerCommissionAmount
      );
    }
  }

  get clientContact() {
    if (this.isManagement) {
      return {
        name: this.detailDataManagement.clientContactName,
        jobLevel: this.detailDataManagement.clientContactJobTitle,
        email: this.detailDataManagement.clientContactEmail,
        phone: this.detailDataManagement.clientContactPhone
      };
    } else {
      return {
        name: this.detailDataRegistration.clientContact.clientContactName,
        jobLevel: this.detailDataRegistration.clientContact
          .clientContactJobTitle,
        email: this.detailDataRegistration.clientContact.clientContactEmail,
        phone: this.detailDataRegistration.clientContact.clientContactPhone
      };
    }
  }

  get clientPartner() {
    if (this.isManagement) {
      return {
        clientPartnerName: this.detailDataManagement.clientPartnerName,
        clientPartnerNumeratorCommission: this.detailDataManagement
          .clientPartnerNumeratorCommission === 'client-rate'
          ? this.$t('clientManagement.registrationFlow.clientPrice').toString()
          : this.$t('clientManagement.renewalRateCard.priceTypeRetail').toString(),
        clientPartnerQuantifierCommission: this.detailDataManagement
          .clientPartnerQuantifierCommission
          ? this.detailDataManagement.clientPartnerQuantifierCommission ===
            "publish_rate_shipping_surcharge"
            ? this.$t("clientManagement.registrationBranchForm.parentClientDetail.publishRateShippingSurcharge").toString()
            : startCase(
                this.detailDataManagement.clientPartnerQuantifierCommission.replace(
                  /_/g,
                  " "
                )
              )
          : "-"
      };
    } else {
      return {
        clientPartnerName: this.detailDataRegistration.clientPartner
          .clientPartnerName,
        clientPartnerNumeratorCommission: this.detailDataRegistration
          .clientPartner.clientPartnerNumeratorCommision === 'client-rate'
          ? this.$t('clientManagement.registrationFlow.clientPrice').toString()
          : this.$t('clientManagement.renewalRateCard.priceTypeRetail').toString(),
        clientPartnerQuantifierCommission: this.detailDataRegistration
          .clientPartner.clientPartnerQuantifierCommission
          ? this.detailDataRegistration.clientPartner
              .clientPartnerQuantifierCommission ===
            "publish_rate_shipping_surcharge"
            ? this.$t("clientManagement.registrationBranchForm.parentClientDetail.publishRateShippingSurcharge").toString()
            : startCase(
                this.detailDataRegistration.clientPartner.clientPartnerQuantifierCommission.replace(
                  /_/g,
                  " "
                )
              )
          : "-"
      };
    }
  }

  startCase(str: string) {
    return startCase(str);
  }

  get defaultClientUpdated() {
    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }

  getNewestUpdatedByKey(key: keyof ClientDetailUpdate) {
    if (this.detailData.detailUpdate[key].length) {
      return (this.detailData.detailUpdate[key] as ClientDetailUpdateItem[])[0]
    }

    return this.defaultClientUpdated
  }

  get newestUpdatedClientDOPaymentType() {
    return this.detailData.detailUpdate.returnInfo?.client_do_payment_type ?? this.defaultClientUpdated
  }

  get isMY() {
    return this.detailData.clientDistrict?.countryCode === "MY";
  }
}
export default ClientDetailCard;
